export default function useDifferenceInDays(d1: Date, d2: Date) {
  d1 = new Date(d1);
  d2 = new Date(d2);
  const diffTime = Math.abs(d2.getTime() - d1.getTime());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return Math.floor(Math.abs(d1.getTime() - d2.getTime()) / 1000 / 60 / 60 / 24)
}
